import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import styles from '@/common/components/Loader/styles.less';

const Loader = () => {
  return (
    <div className={styles.loader}>
      <CircularProgress color="success" />
    </div>
  );
};

export default Loader;
